export default __webpack_public_path__ + "static/media/IMG-20240822-WA0005.f617ec19.jpg";